import { INTERNAL_ROUTES } from '../static/Urls';
import apiService from '../service/ApiService';
import { Operation } from '../static/Messages';
import { legacyGetOnError, legacyPostPutOnError, ValidationFailure } from './ApiUtils';
import { FetchUserContactDetails, UpdateUserContactDetails } from '@shared/api/dto/UserContactDetails';

const userContactDetailsApiUrl = INTERNAL_ROUTES.API_PATH + '/api/usercontactdetails';

const fetchUserContactDetails = (): Promise<FetchUserContactDetails> => {
  return apiService.callGet<FetchUserContactDetails>(
    userContactDetailsApiUrl,
    { withCredentials: true },
    undefined,
    legacyGetOnError(),
  );
};

const updateUserContactDetails = (
  payload: UpdateUserContactDetails,
): Promise<string | Record<string, ValidationFailure>> => {
  return apiService.callPut<FetchUserContactDetails, string | Record<string, ValidationFailure>>(
    userContactDetailsApiUrl,
    payload,
    { withCredentials: true },
    { message: Operation.userContactUpdateSuccess },
    legacyPostPutOnError(),
  );
};

const userContactApi = {
  fetch: fetchUserContactDetails,
  update: updateUserContactDetails,
};

export default userContactApi;
